const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '长相思 第二季',
    type: '电视剧',
    hot: '本周最热',
    desc: '古装神话巨制续作，杨紫主演年度大剧',
    views: '528.3万',
  },
  {
    id: 2,
    rank: 2,
    title: '消失的她',
    type: '电影',
    hot: '口碑飙升',
    desc: '朱一龙、倪妮主演悬疑力作，反转不断',
    views: '412.7万',
  },
  {
    id: 3,
    rank: 3,
    title: '奔跑吧 最新季',
    type: '综艺',
    hot: '持续热播',
    desc: '国民级户外真人秀，笑点密集全程高能',
    views: '389.5万',
  },
  {
    id: 4,
    rank: 4,
    title: '斗破苍穹 年番',
    type: '动漫',
    hot: '人气爆棚',
    desc: '国漫顶级IP，特效炸裂剧情高燃',
    views: '356.2万',
  },
  {
    id: 5,
    rank: 5,
    title: '流浪地球2',
    type: '电影',
    hot: '科幻标杆',
    desc: '国产科幻巅峰之作，视觉震撼情感动人',
    views: '298.8万',
  },
];

const getRankBadge = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-primary-400 text-background-50';
  if (rank === 3) return 'bg-secondary-400 text-background-50';
  return 'bg-background-200 text-foreground-600';
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-trophy-line"></i>
            <span>热门排行</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            本周最受欢迎的热门影视内容排行
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${getRankBadge(item.rank)}`}>
                <span className="text-sm font-bold">{item.rank}</span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                    {item.type}
                  </span>
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.hot}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 mt-1">{item.desc}</p>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-1 text-primary-500">
                  <i className="ri-eye-line text-xs"></i>
                  <span className="text-sm font-semibold">{item.views}</span>
                </div>
                <span className="text-xs text-foreground-400">次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}